define('views/components/manual_payment_transaction/manual_payment_transaction_list',['require','views/base/list_view','views/components/manual_payment_transaction/manual_payment_transaction','text!templates/components/manual_payment_transaction/manual_payment_transaction_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/manual_payment_transaction/manual_payment_transaction');

    var temp = require("text!templates/components/manual_payment_transaction/manual_payment_transaction_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

